
<div class="mainHotel " style="padding: 0;margin: 0;" >

  <div style="margin-top: 20px;overflow-y: auto;max-height: 100%;" (scroll)="onScroll($event)">
<app-hotel style="font-size: small;" (myOutput)="searchHotel()" ></app-hotel>

    
    
    
    
<div class=" col-md-12  " style="max-width: 100%; margin-top: -80px;position: relative;  min-width:100%;"  > 
  <div *ngIf="showDetails" class="col-md-12" style="margin-top: 20px; " >
    <app-hotel-details (myOutput)="backClick()"></app-hotel-details>
        <!-- <div id="map"></div> -->

    </div>
    <div *ngIf="!showDetails" class="d-flex justify-content-center col-md-11 " style="padding-left: 40px; min-width: 1200px;max-width:1400 ;" >
<!-- <div *ngIf="!showDetails" class=" col-md-9 row d-flex justify-content-center" > -->
   
<!--###################################   Filter ##################################################
     ###################################   Filter ################################################## 
      ###################################   Filter ##################################################-->
  <div *ngIf="!filters && hotelList" class="col-md-3 d-flex justify-content-end mt-3  pb-2  " style="margin: 0;padding: 0; " >
    

    <div  class="col-md-10  mb-2  pb-2 sticky-tabs" style="height: 90vh;overflow-y: auto;" >
    
      
    <div style="width: 100%;" class="mt-2 pt-2 pb-2 active">
      <div class=" pt-3" style="min-width:100%; padding-right: 15px;padding-left: 15px; margin-right: 8px;"  > <button  mat-raised-button style="width: 100%; background-color: #1876D1;color: white; ;" disabled><mat-icon>hotel</mat-icon>Hotel Name </button></div> 
      
    
      <div class="form-control  " style="width: 95%;margin: 5px;">
        <ng-select
       
        [items]="hotelName"
        bindLabel="name"
        [searchable]="true"
        (change)="combineFilters()"
        (input)="combineSelectFilters($event)"
        [virtualScroll]="true"
        [multiple]="true"
        [(ngModel)]="hotel"
        [closeOnSelect]="false"
        [hideSelected]="true"
        class="classHotelSelection">
        
        <ng-template ng-option-tmp let-item="item" >
           {{item }}
        </ng-template>
      </ng-select>
        <!-- <input
          matInput
          style="outline: none;border: none;border-bottom: 1px solic #757575;"
          (input)="autoBill.open()"
          (focus)="autoBill.open()"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="filterNames()"
          panelClass="force-downward"/>
        <mat-select  multiple     [(ngModel)]="hotel"  (selectionChange)="combineFilters()" 
        #autoBill="matSelect">
          
          <mat-option class="mat-primary " style="margin-top: 1px;" *ngFor="let name of filteredNames ;let i=index" [ngClass]="{'odd-row': i % 2 !== 0, 'even-row': i % 2 === 0}" [value]="name">{{name}}</mat-option>
        </mat-select> -->
        <!-- <mat-menu #showDialog="matMenu"  >
          <mat-selection-list [(ngModel)]="hotel"  (click)="combineFilters()" (click)="onMenuClick($event)" style="max-height: 40vh;">
            <mat-list-option color="primary" checkboxPosition="before" *ngFor="let name of filteredNames" [value]="name"  style="font-size: 12px;">{{name}}</mat-list-option>
                 </mat-selection-list>
          
        </mat-menu> -->
      </div>
      <!-- <div class=" pt-3" style="min-width:100%; padding-right: 15px;padding-left: 15px; margin-right: 8px;"  > <button  mat-raised-button style="width: 100%; background-color: #1876D1;color: white; ;" disabled><mat-icon>location</mat-icon>Location </button></div> 

      <div class="input-group" style="width: 95%;margin: 5px;">
                <span class="input-group-addon">
                    <i class="fa fa-map-marker"></i>
                </span>
                <input style="outline: none;border: none;border-bottom: 1px solic #757575;"
                 type="text" class="form-control" placeholder="Enter location"  [(ngModel)]="addresstextValue" #addresstextInput>
            </div> -->
      


    <div class=" pt-3" style="min-width:100%; padding-right: 15px;padding-left: 15px; margin-right: 8px;" (click)="sortByPrice()" > <button  mat-raised-button style="width: 100%; background-color: #1876D1;color: white;"><mat-icon>swap_vert</mat-icon>Price </button></div> 
    <div class="col-md-12 mt-3 " style="padding-left: 15px;padding-right: 15px; ">
      <input type="text" class="form-control" style="color: #757575;text-align: center;"  (keypress)="onlyNumberKey($event)"  pInputText [(ngModel)]="value" (input)="combineFilters()" class=" mb-3"/>
      <p-slider [(ngModel)]="value"  [max]="maxPrice" 
      [min]="minPrice" class="w-full" (onChange)="combineFilters()" />
      
  </div>
    <div class="col-md-12 d-flex justify-content-center">
    
      <div class="d-flex justify-content-end col-md-3" style="padding: 4px; margin-right: 8px;  " ><small style="color: #757575;">₹{{minPrice}}</small></div>

    <div class=" col-md-5" style="  margin:3px;  margin-top:-4px ; padding: 0;"  > 
     
      
</div> 

    <div style=" padding: 4px; margin-right: 8px; "  class="col-md-3"><small style="color: #757575;">₹{{maxPrice}}</small></div>
  </div>
  
    
    
    
     <div class="col-md-12 d-flex justify-content-center">
  <div class="mt-3 col-md-11 row" style="border: 1px solid #1876D1;border-radius: 4px; "  aria-label="Example icon-button with a menu"><button class="mb-2" disabled mat-raised-button style="width: 100%;background-color: #1876D1;;font-weight: 700;color: white;">Star Rating </button>
    <div class="col-md-12 row mb-2">
    <div  *ngFor="let star of sortStars(starNumbers)"           (click)="combineFilters();onMenuClick($event)"
    class="field-checkbox">
    <div class="rating-container">
      <p-checkbox 
          [(ngModel)]="filterTime"
          label=""
          name="group" 
          [value]="star" 
          />
      <p-rating [ngModel]="star"class="rating-image" readonly [cancel]="false"></p-rating>
    </div>
  </div>
    

  </div>
    
  </div>
</div>
  
  
  
  
<div class="col-md-12 d-flex justify-content-center">
  <div class="mt-3 col-md-11 row" (click)="combineFilters()" style="border: 1px solid #1876D1;border-radius: 4px"  aria-label="Example icon-button with a menu"><button class="mb-2" mat-raised-button style="width: 100%; background-color: #1876D1;font-weight: 700;color: white;" disabled>User Rating </button>
     
        <div class="col-md-12 row mb-2">


        <div class="rating-container" >
          <p-checkbox 
              [(ngModel)]="rating"
              label=""
              name="group" 
              value="4.2" 
              label="Excellent: 4.2+"
              />
              <!-- <span class="rating-image"> Excellent: 4.2+</span> -->
          <!-- <p-rating [ngModel]="star"class="rating-image" readonly [cancel]="false"></p-rating> -->
        </div>

        <div class="rating-container">
          <p-checkbox 
              [(ngModel)]="rating"
              label=""
              name="group" 
              value="3.5" 
              label="Very Good: 3.5+"

              />
              <!-- <span class="rating-image"> Very Good: 3.5+</span> -->
          <!-- <p-rating [ngModel]="star"class="rating-image" readonly [cancel]="false"></p-rating> -->
        </div>
        <div class="rating-container">
          <p-checkbox 
              [(ngModel)]="rating"
              label=""
              name="group" 
              value="3" 
              label="Good: 3+"
              />
          <!-- <p-rating [ngModel]="star"class="rating-image" readonly [cancel]="false"></p-rating> -->
        </div>
  </div> 
  </div>
</div>

<div class="col-md-12 d-flex justify-content-center">
  <div class="mt-3 col-md-11 row" (click)="combineFilters()" style="border: 1px solid #1876D1;border-radius: 4px"  aria-label="Example icon-button with a menu"><button class="mb-2" mat-raised-button style="width: 100%; background-color: #1876D1;font-weight: 700;color: white;" disabled>Meal Basis </button>
     
        <div class="col-md-12 row mb-2">


        <div class="rating-container" *ngFor="let meals of mealsList" >
          <p-checkbox 
              [(ngModel)]="meal"
              label=""
              name="group" 
              [value]="meals" 
              [label]="meals"
              />
          <!-- <p-rating [ngModel]="star"class="rating-image" readonly [cancel]="false"></p-rating> -->
        </div>
        <!-- <div class="rating-container" >
          <p-checkbox 
              [(ngModel)]="meal"
              label=""
              name="group" 
              value="Room with Breakfast" 
              label="Room with Breakfast"
              />
          <p-rating [ngModel]="star"class="rating-image" readonly [cancel]="false"></p-rating> 
        </div> -->
  </div> 
  </div>
</div>

<div class="col-md-12 d-flex justify-content-center" *ngIf="loginUserType==='STAFF'">
  <div class="mt-3 col-md-11 row" (click)="combineFilters()" style="border: 1px solid #1876D1;border-radius: 4px"  aria-label="Example icon-button with a menu"><button class="mb-2" mat-raised-button style="width: 100%; background-color: #1876D1;font-weight: 700;color: white;" disabled>Stats </button>
     
        <div class="col-md-12 row mb-2">


        <div class="rating-container upperCase" *ngFor="let sources of sourceName" >
          <p-checkbox 
              [(ngModel)]="source"
              label=""
              name="group"  
              [value]="sources" 
              [label]="sources"
              />
             
        </div>
       
  </div> 
  </div>
</div>

  
  
  
  
  
  <!-- <div class="pt-3"style="padding-right: 15px;padding-left: 15px; margin-right: 8px;min-width:100%;"  aria-label="Example icon-button with a menu"><button mat-raised-button style="width: 100%; background-color: transparent;font-weight: 700;" disabled>Room Amenities </button>
      <mat-selection-list   (click)="onMenuClick($event)" style=" background-color: white;">
        <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 12px;"> 
          Home Theatre
        </mat-list-option>
       
        <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 12px;"> 
          Spa Tub

        </mat-list-option>
        <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;"> 
          Smoking Room
</mat-list-option>
<mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;"> 
  Cook & Butler Service
</mat-list-option>
<mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;"> 
  Private Pool
</mat-list-option>
        
        

        </mat-selection-list> 
  </div>  -->



  
  
  
  
  
</div>
</div>
  </div>
  
  <div *ngIf="!showDetails" class=" col-md-10 mt-3   row d-flex justify-content-center " style="margin: 0;padding: 0;" >

    
<!-- <div  *ngIf="returnflight"   [ngClass]="filters===false?('col-md-9'):'col-md-12'" [style]="filters===true?('margin-top:-20px'):''"> -->
  <div  *ngIf="hotelList"  class="col-md-12"  style="margin-left: 0;padding-left: 0; margin-top: 0;padding-top:0 ;" >
  
  
  <!--##############filter#################=============================================================================-->
<!--###################################   filter ##################################################
     ###################################  filter ################################################## 
      ################################### filter ##################################################-->
      <mat-expansion-panel *ngIf="filters"  hideToggle disabled style=" margin-left: 20px; margin-right: 20px;  min-height: 50px;">
   
        <mat-expansion-panel-header style="background-color: transparent;">
          <mat-panel-title style="background-color: transparent;">
            <div class="col-md-12 row  bold" style="color:rgb(32,32,32); font-size: 18px;">
             
                <div class="col-md-12 d-flex justify-content-end">
                  <div class=" "   style="min-width:100px; padding: 4px; margin-right: 8px;" >
                   
                  </div> 

                  <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" (click)="sortByPrice()" > <button mat-raised-button><mat-icon>swap_vert</mat-icon>Price </button></div> 

                  <div class="d-flex justify-content-end" style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{minPrice}}</div>

                  <div class=" " style="min-width:100px;  margin:0;  margin-top:-4px ; padding: 0;"  > 
                     <mat-slider     
                    style="margin: 0;padding: 0; "
                    class="example-margin"
                    [max]="maxPrice"
                    [min]="minPrice"
                    step="0"
                    [discrete]="'false'"
                    [showTickMarks]="'false'">
                  <input matSliderThumb [(ngModel)]="value" (input)="filterByBaseFare()" #slider>
                </mat-slider></div> 

                  <div style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{maxPrice}}</div>
                  <div class=" "style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="showTimeDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Star Rating </button>
                    
                    <mat-menu #showTimeDialog="matMenu"  >
                      <mat-selection-list [(ngModel)]="filterTime"  (click)="onMenuClick($event)">
                        <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 12px;"> <small style="font-size: xx-small;">
                          <img src="../../../assets/images/star.png" width="20" height="20" alt="">
            
                        </small></mat-list-option>
                       
                        <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 12px;"> <small style="font-size: xx-small;">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
             
                        </small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;"> <small style="font-size: xx-small;">
                        
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt=""></small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 12px;"> <small style="font-size: xx-small;">
                          <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
             
                        </small></mat-list-option>
                        <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 12px;"><small style="font-size: xx-small;">  
                          <img src="../../../assets/images/star.png" width="20" height="20" alt="">
                          <img src="../../../assets/images/star.png" width="20" height="20" alt="">
                          <img src="../../../assets/images/star.png" width="20" height="20" alt="">
                          <img src="../../../assets/images/star.png" width="20" height="20" alt="">
                          <img src="../../../assets/images/star.png" width="20" height="20" alt=""></small></mat-list-option>
                
                        </mat-selection-list>
                    </mat-menu> </div>
                 
                  <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;" ><button mat-raised-button (click)="moreFilters()"><mat-icon>tune</mat-icon> Filters</button></div> 
    
                  
                 
                 
                </div>  
            </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
       
      </mat-expansion-panel>

     

        <!--##############hotel Detail#################=============================================================================-->
<!--###################################   hotel Detail ##################################################
     ###################################  hotel Detail ################################################## 
      ################################### hotel Detail ##################################################-->
<span *ngIf="hotelList">
  
  <div  style="margin-bottom:80px;margin-left: 0; padding-left: 0; margin-top: 0; padding-top: 0; overflow-y: auto;height: 100%;" 
   >
    <!-- [expanded]="true" hideToggle  disabled="true"
    (click)="setStep(1);" -->


    <!-- (mouseover)="attachButtonHoverEvent(item)" -->
  <div  class="active"   *ngFor="let item of visibleHotels;let t=index " id="hoverButton"     style="margin-top: 5px;  margin-left: 20px; margin-right: 20px; height:300px;cursor: pointer;overflow-y: auto;" >
<!-- <span *ngIf="skeleton">
    <p-skeleton styleClass="mb-2" />
    <p-skeleton width="10rem" styleClass="mb-2" />
    <p-skeleton width="5rem" styleClass="mb-2" />
    <p-skeleton height="2rem" styleClass="mb-2" />
    <p-skeleton width="10rem" height="4rem" />
  </span>
*ngIf="!skeleton" -->
    <div  class="col-md-12 row" >
      <div style="color: rgb(33,33,33);" class="col-md-4" style="padding-top: 12px; padding-left: 20px;" >
           <!-- <img  src="../../../assets/images/hotelroom2.avif" width="100%" height="100%" alt=""> -->
           <div class="slideshow-container">
            <div *ngFor="let slide of item.slides; let i = index" class="mySlides " [style.display]="item.slideIndex-1 === i ? 'block' : 'none'">
              <div class="numbertext">{{ i + 1 }} / {{ item.slides.length }}</div>
              <img [src]="slide?.url" loading="lazy" style="width:100% ;max-height:150px;min-height:110px ;border-radius: 4px;">
              <!-- <div class="text">{{ slide.caption }}</div> -->
            </div>
            <a class="prev" (click)="plusSlides(-1,item)">❮</a>
            <a class="next" (click)="plusSlides(1,item)">❯</a>
          </div>
          <br>
          
          <div style="text-align:center" class="d-flex justify-content-center">
            <span class="dot"  *ngIf="item.slides[0]?.url" (click)="currentSlide(0+1,item)" [class.actives]="item.slideIndex-1 === 0">               
              <img [src]="item.slides[0]?.url" loading="lazy" style="width:100% ;height: 40px;">

            </span>
            <span *ngIf="item.slides[1]?.url" class="dot"  (click)="currentSlide(1+1,item)" [class.actives]="item.slideIndex-1 === 1">               
              <img [src]="item.slides[1]?.url" loading="lazy" style="width:100% ;height: 40px;">

            </span>
            <span *ngIf="item.slides[2]?.url" class="dot"  (click)="currentSlide(2+1,item)" [class.actives]="item.slideIndex-1 === 2">               
              <img [src]="item.slides[2]?.url" loading="lazy" style="width:100% ;height: 40px;">

            </span>
            <span *ngIf="item.slides[3]?.url" class="dot"  (click)="currentSlide(3+1,item)" [class.actives]="item.slideIndex-1 === 3">               
              <img [src]="item.slides[3]?.url" loading="lazy" style="width:100% ;height: 40px;">

            </span>
            <!-- <span *ngIf="item.slides[4].url" class="dot"  (click)="currentSlide(4+1,item)" [class.actives]="item.slideIndex-1 === 4">               
              <img [src]="item.slides[4]?.url" loading="lazy" style="width:100% ;height: 40px;">

            </span> -->
           
           
          </div>

      </div>
        <div class="col-md-5 "  >
          <div class="col-md-12 mt-3" style="text-align: left;">
            <div class="">
              <h5 class="" style="cursor: pointer;" (click)="onClickDetails(item,'all')">{{item?.name}}&nbsp;</h5>
              <span style="font-size: 14;font-weight: 400;color: #8B5629;">{{item?.address||''}}</span><br>
            <p-rating [ngModel]="item.starRating" readonly [cancel]="false" />

              <!-- <small *ngFor="let start of starArray(item.starRating)"> 

                <img  src="../../../assets/images/star.png" width="18" height="18" alt="">
                </small> -->
                <!-- <div style="height: 2vh;overflow-y: auto;"  id="map" class=" cards  mt-2 col-md-12 sticky-tabs"  >
    
                </div>  -->
                <div class="pt-2"><small style="color: rgb(31, 99, 202);cursor: pointer;font-weight: 600;" (click)="onClickDetails(item,'location')">View on map</small></div>
                  <!-- <div id="map" class="map-container"></div> -->
              <!-- <small>Vaishali, Ghaziabad | 28.0 km from Delhi city centre</small> -->
            </div>
            <div  class="pt-2 col-md-12 d-flex justify-content-start"><small  *ngFor="let amenities of findAmenities(item.amenities)">
              
    
    
    
    
    

              <span  style="color: #757575;" *ngIf="amenities.displayName==='Restaurant'"><mat-icon > restaurant_menu</mat-icon>Restaurant</span>
              <span style="color: #757575;" *ngIf="amenities.displayName==='Gym/ Fitness centre'"><mat-icon >fitness_center</mat-icon>Gym</span>
              <span style="color: #757575;" *ngIf="amenities.displayName==='Swimming Pool'"><mat-icon >pool</mat-icon>Pool</span>
              <span style="color: #757575;" *ngIf="amenities.displayName==='Smoking rooms'"><mat-icon >smoking_rooms</mat-icon>Smoking rooms</span>

         
            </small></div>
            <div class="pt-2"><small style="color: #8B5629;">{{item?.rooms[0]?.name}}</small></div>


            

            <!-- <div class="pt-2"><small style="color: green;" *ngFor="let inclusions of lengthFixed(item?.rooms[0]?.ratePlans[0]?.inclusions) ">
              <mat-icon style="font-size:20px;">check_circle_outline</mat-icon>{{inclusions?.name}}<br>
            </small></div> -->
            

            

            
            <!-- <div>
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt="">
              <img src="../../../assets/images/star.png" width="20" height="20" alt=""></div> -->
                <!-- <div class="py-4 ">
                  <div class=" ">
                <div class="pt-1 px-3 "><span class="">Paseo Punta Ixtapa, Lote 2, IXTAPA , 40880.</span></div></div> <div class="flex mb-2 max-h-[8rem] overflow-y-auto">
              <div class="pt-1 flex flex-col"><div class=""><div><p>The luxury, eco-friendly resort offers spectacular views from any of its suites.<br>
3 restaurants with a la carte service, Mexican Style, Italian and Oriental, 1 international buffet restaurant for breakfast, lunch and dinner with show cooking-<br>
Snack and room service available.<br>
Lobby bar divided into 3 rooms with maximum capacity of 400 people, two bars on the side of the pool and swim-up pool with waterfall type Tepuy.</p>
</div></div><span class="px-3 text-xs text-primary " style="cursor: pointer;" >Read more</span></div></div></div> -->
<!-- <div class="col-md-12 row">
<div class="col-md-6 " style="text-align: left;">
<p>4.5</p>
</div>
<div class="col-md-6" style="text-align: right;">
  <button     mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book</button>

</div>
</div> -->
</div>
<div class="pt-2" ><small style="color: rgb(31, 99, 202);cursor: pointer;font-weight: 700; font-size: 20px;" (click)="onClickDetails(item,'all')">Full Description</small></div>

        </div>
        <div  class="col-md-3 pt-3 "   style="border-left: 1px solid rgb(182, 179, 179);text-align: right; ">
          
          <div class="" > <span [ngbPopover]="popoverContent" container="body"
            triggers="mouseenter:mouseleave" style="color:rgb(31, 99, 202);font-weight: 700;">{{rateMapping(item?.reviewDetails?.rating||item?.starRating)}} </span>  <span style="background-color: rgb(31, 99, 202);color: white;padding: 4px; border-radius: 4px;"> {{item?.reviewDetails?.rating||item?.starRating}}</span>
          
            <ng-template #popoverContent class="col-md-12" >
<small style="font-size: 10px;">Based on {{item?.reviewDetails?.totalRatingCount}} Ratings </small>
  <!-- and 3405 reviews -->

<mat-progress-bar mode="determinate" value="40"></mat-progress-bar>

</ng-template>
          </div>
         <div class=""><small >({{item?.reviewDetails?.totalRatingCount}} Ratings)</small></div>
         <div class="pt-2"><small style="color:#757575">Starts From </small></div>
         <div *ngIf="item?.rooms[0]?.rate?.corporate===true&&loginUserType==='STAFF'" class="stamp-container d-flex justify-content-end">         
         <div  class="business-tab">
          Business Friendly
        </div></div>
         <span class=""><strong style="font-size:xx-large;">₹ {{item?.rooms[0]?.rate?.totalAmount}}</strong></span>
         <span *ngIf="item?.rooms[0]?.rate?.packageRate===true" class="stamp-container d-flex justify-content-end">
          <button disabled class="stamp-button">Special Rate</button>
         </span>
         <!-- <div class=""><small>+₹ {{item?.rooms[0]?.ratePlans[0]?.price?.totalTax}} taxes & fees </small></div> -->
         <div class=""><small style="color:#757575">Per Night for {{messageData.roomCount}} {{messageData.roomCount>1?('Rooms'):'Room'}} </small></div>
                 <span class=""><small style="color:#757575">{{item?.rooms[0]?.rate?.description||'-'}}</small></span>

         <!-- <span class=""><small style="color:#757575">{{item?.rooms[0]?.ratePlans[0]?.description||'-'}}</small></span> -->


         <!-- <div class=""><small style="color: green;">{{item.rooms[0]?.ratePlans[0]?.price?.couponDiscount?("Coupon Code ("+item.rooms[0]?.ratePlans[0]?.price?.couponCode+")"):""}}

        </small></div> -->
         <!-- <div class=""><small> {{item.rooms[0]?.ratePlans[0]?.price?.couponDiscount?(item.rooms[0]?.ratePlans[0]?.price?.couponDiscount+" INR Coupon Discount"):""}}
        </small></div> -->

         <br>
         <div class=""><button   mat-flat-button  style=" width: 100%; background-color:rgb(31, 99, 202); color: white;" (click)="onClickDetails(item,'rooms')" >Check Rooms <mat-icon>keyboard_arrow_down</mat-icon></button>
         </div>


         
        </div>
      
      
      </div>
  
  
    
    </div>

    <!-- <div  *ngIf="!showPanding&&next!=-1" class=" active   mb-2 mt-2" style="color: rgb(6, 98, 202);cursor: pointer;margin-left: 20px; margin-right: 20px;"  (click)="nextData()">More Hotels ...</div>
<div *ngIf="showPanding" class="mb-2 mt-2 col-md-12 d-flex justify-content-center " style="margin-left: 20px; margin-right: 20px;" >
  <p-progressSpinner 
  styleClass="w-4rem h-4rem" 
  strokeWidth="8" 
  fill="var(--surface-ground)" 
  animationDuration=".5s" />
 
</div> -->
</div>
</span>



      
</div>

</div>

<div *ngIf="false" class="col-md-3 row pt-4 " style="width: 370px;">
  <!-- <div id="map" style="height: 430px;"></div> -->

  <!-- <google-map 
  height="400px" 
  width="100%" 
  [center]="center" 
  [zoom]="zoom">
</google-map> -->
<!-- <div style="height: 90vh;overflow-y: auto;"  id="map" class=" cards  mt-2 col-md-12 sticky-tabs"  >
    
</div>  -->

  
  
    
    
    
    
  <!-- <div style="height: 20px; width:20px;z-index: 2; background-color: black;"  id="mapMain" class=" cards pt-2 mt-2 col-md-12 "  >
  </div>  -->
  
  
</div>
</div>
<!--###################################  pendingFlight.gif ##################################################
     ################################### pendingFlight.gif  ################################################## 
      ################################### pendingFlight.gif ##################################################-->
<div *ngIf="showPending" >
  <div class="gif-container">
    <img src="../../../assets/images/image_processing20210217-16671-11ezcsw.gif" >
</div>
</div>


    
    
    



